import { Component, OnInit } from '@angular/core';
import { Inject } from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA
} from "@angular/material/dialog";
import {
  ThingsComponent,
  DialogData
} from "../things.component";
import { ThingUiObject } from 'src/app/_models/thingUiObject';


@Component({
  selector: 'app-msater-control',
  templateUrl: './msater-control.component.html',
  styleUrls: ['./msater-control.component.css']
})
export class MsaterControlComponent implements OnInit {
  masterStatus: string
  datainput: string;
  constructor(
    public dialogRef: MatDialogRef<ThingsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }

  ngOnInit() { }
  onNoClick(): void {
    this.dialogRef.close();
  }
  masterControl(status) {
    this.masterStatus = status
    console.log(this.masterStatus)
  }
}

